import { render, staticRenderFns } from "./BillingIFrame.vue?vue&type=template&id=491f7cd4&scoped=true&"
import script from "./BillingIFrame.vue?vue&type=script&lang=ts&"
export * from "./BillingIFrame.vue?vue&type=script&lang=ts&"
import style0 from "./BillingIFrame.vue?vue&type=style&index=0&id=491f7cd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f7cd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
